module.exports = __webpack_public_path__ + "media/images/icon_list/sns_images-3040eca4b785d44812031ceec0440542.svg";